'use client';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

interface Props {
  icon: (option: string) => Icon | undefined;
  options: Array<string>;
  selectedOption: string;
  setSelectedOption: (option: string) => void;
}

const selectedClassName = (option: string, selectedOption: string) =>
  option !== selectedOption
    ? 'cursor-pointer px-1.5'
    : 'cursor-pointer px-1.5 text-pill-color rounded-md bg-pill-background-color';

const IconSelect = ({
  icon,
  options,
  selectedOption,
  setSelectedOption,
}: Props) => (
  <div className={'flex flex-row'}>
    {options.map((option) => (
      <div
        className={selectedClassName(option, selectedOption)}
        key={`icon-select-${option}`}
        data-testid={`icon-select-option-${option}`}
        onClick={() => setSelectedOption(option)}
      >
        <IconView icon={icon(option)} size={'1x'} />
      </div>
    ))}
  </div>
);

export default IconSelect;
